/* eslint-disable */

import toast from '@/services/toast';

export default {
  name: 'unit-info-add',
  components: {
  },
  props: [],
  data() {
    return {
      quizData: {
        name: '',
      },
      submitted:false,
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    validateCreateUnitBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let data = {
            name: this.quizData.name,
          }
          this.$store.dispatch('postIvQuizUniInfoAction', data)
          .then((res) => {
              toast.success(res.data.msg);
              this.$router.push('/interview/quiz/unit/list/')
              this.submitted = false;
            })
            .catch((err) => {
              this.submitted = false;
            })
          return
        }
      });
    },
  },
}